import { ResourceRelationsService } from "../../services/ResourceRelationsService";
import { IAutocompleteParams, OptionType } from "../ResourcesAutocompleteMI";
import { IIssueResourceData } from "./IssueForRelations";

interface IParams {
	defaultResources: string,
	resourcesData: IIssueResourceData[],
	kind: "Application" | "ServiceAsset",
	maxRows: number,
	filterId: string,
	multiple: boolean,

	callback: (data: OptionType[]) => void,
}

export default function setDefaultOptionsLoader(props: IParams) {

	function sendSelect(defaultItems: OptionType[]) {
		if (!defaultItems || defaultItems.length == 0)
			return;

		if (!props.multiple) {

			defaultItems = [defaultItems[0]]
		}

		props.callback(defaultItems);
	}

	if (props.defaultResources === "[fromResources]") {
		let defaultItems: OptionType[];
		if (!props.resourcesData || props.resourcesData.length == 0) {
			console.log(`No resources in issue for '${props.kind}'.`);
		}
		defaultItems = props.resourcesData.map(x => {
			return {
				value: x.id.toString(),
				label: x.label,
				kind: props.kind,
			};
		});

		sendSelect(defaultItems);
	}

	if (props.defaultResources.startsWith("[search:")) {
		let service = new ResourceRelationsService();

		let searchTextTemp = props.defaultResources;
		let serachPrefixLength = "[search:".length;
		let chunks = searchTextTemp.substr(serachPrefixLength, searchTextTemp.length - serachPrefixLength - 1).split(',');

		let maxRows = parseInt(chunks[0])
		if (isNaN(maxRows))
			maxRows = props.maxRows;

		let params: IAutocompleteParams = {
			maxRows: maxRows,
			filterId: props.filterId,
		}

		service.getResources(props.kind, params, chunks[1], (data) => {

			if (chunks[1] === data.searchText) {
				const results: OptionType[] = data.options.map(x => dataMapper(x, props.kind));

				if (results.length == 0) {
					console.log(`No resources found for '${props.kind}'.`);
				}

				sendSelect(results);
			}
		});
	}
}

function dataMapper(item: { id: number, value: string, label: string }, kind: string): OptionType {

	return {
		value: item.id.toString(),
		label: item.label,
		kind: kind,
	};
}